import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-100/95 backdrop-blur-md border-b border-background-300/30'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-movie-2-line text-2xl text-primary-500"></i>
            </div>
            <span className="text-xl font-heading font-bold text-foreground-50 whitespace-nowrap">
              天天影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                isHome ? 'text-primary-500' : 'text-foreground-300 hover:text-foreground-50'
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`flex items-center gap-1 text-sm font-medium whitespace-nowrap transition-colors ${
                  location.pathname.startsWith('/category')
                    ? 'text-primary-500'
                    : 'text-foreground-300 hover:text-foreground-50'
                }`}
              >
                电影分类
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`ri-arrow-down-s-line text-xs transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
                </div>
              </button>

              {categoryOpen && (
                <>
                  <div className="fixed inset-0 z-40" onClick={() => setCategoryOpen(false)}></div>
                  <div className="absolute top-full left-0 mt-2 w-48 bg-background-100 border border-background-300/50 rounded-lg overflow-hidden z-50">
                    {categories.map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        className="flex items-center gap-3 px-4 py-3 text-sm text-foreground-300 hover:text-foreground-50 hover:bg-background-200/70 transition-colors"
                      >
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className={`${cat.icon} text-primary-500`}></i>
                        </div>
                        {cat.name}
                      </Link>
                    ))}
                  </div>
                </>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname === '/about' ? 'text-primary-500' : 'text-foreground-300 hover:text-foreground-50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-lg border border-background-300/40 text-foreground-400 hover:text-foreground-100 hover:border-background-400/60 transition-colors cursor-pointer">
              <i className="ri-search-line text-lg"></i>
            </button>
            <Link
              to="/category/action"
              className="px-5 py-2 whitespace-nowrap rounded-full bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer"
            >
              立即观影
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-200 cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-background-100 border-t border-background-300/30 pb-4">
            <div className="flex flex-col gap-1 pt-2">
              <Link to="/" className="px-4 py-3 text-sm text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50 rounded-lg transition-colors">
                首页
              </Link>
              <div className="px-4 py-2 text-xs text-foreground-500 font-medium uppercase tracking-wider">
                电影分类
              </div>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex items-center gap-3 px-4 py-3 text-sm text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50 rounded-lg transition-colors"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${cat.icon} text-primary-500`}></i>
                  </div>
                  {cat.name}
                </Link>
              ))}
              <Link to="/about" className="px-4 py-3 text-sm text-foreground-300 hover:text-foreground-50 hover:bg-background-200/50 rounded-lg transition-colors">
                关于我们
              </Link>
              <div className="px-4 pt-2">
                <Link
                  to="/category/action"
                  className="block w-full text-center py-2.5 whitespace-nowrap rounded-full bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  立即观影
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}